export enum EMetricSystem {
  Metric = 'Metric',
  Imperial = 'Imperial',
}
